/** Mock data aligned with nexus-ui-mock/nexsus.png — replace with API later */

export const NEXUS_READOUT = {
  title: 'AI Market Readout',
  synthesizedFrom: 5,
  updatedLabel: 'Updated just now',
  bullets: [
    'Allianz and MassMutual show the strongest near-term product signals.',
    'Pacific Life activity suggests state-level rollout momentum.',
    'LinkedIn and Meta ad activity highlight annuity and whole-life messaging from MassMutual.',
  ],
};

export const NEXUS_SERFF_ITEMS = [
  {
    company: 'Pacific Life',
    filingCount: 3,
    detail: '3 filings',
    meta: 'Indexed UL filing · Florida, Texas',
    time: '2d ago',
  },
  {
    company: 'Lincoln Financial',
    filingCount: 1,
    detail: '1 filing',
    meta: 'Form amendment · Texas',
    time: '5d ago',
  },
];

export const NEXUS_SEC_ITEMS = [
  {
    company: 'Allianz Life',
    filingCount: 1,
    detail: '1 filing',
    meta: '10-K/A',
    time: 'Today',
    isNew: true,
  },
  {
    company: 'MassMutual',
    filingCount: 2,
    detail: '2 filings',
    meta: '497/PII supplement +1 more',
    time: 'Today',
    isNew: true,
  },
];

export const NEXUS_NEWS_ITEMS = [
  {
    headline: 'Prudential expands retirement offering',
    time: '1d ago',
    summary:
      'The carrier announced an expanded suite of retirement income tools aimed at advisor-led distribution channels.',
  },
  {
    headline: 'New York Life distribution partnership announced',
    time: '2d ago',
    summary:
      'A new strategic partnership is expected to broaden access to annuity products in select regional markets.',
  },
];

/** platform: linkedin | meta — matches mi_linkedin_ads / mi_meta_ads */
export const NEXUS_LINKEDIN_ADS_ITEMS = [
  {
    platform: 'linkedin',
    company: 'MassMutual',
    title: 'How the Financially Divided Workforce Is Changing Voluntary Benefits',
    subtitle: 'LinkedIn · Webinar promotion',
    time: 'Active · seen today',
    image: 'linkedin',
  },
  {
    platform: 'linkedin',
    company: 'MassMutual',
    title: 'MassMutual Whole Life: Expect More.',
    subtitle: 'LinkedIn · Living Well Rider',
    time: 'Active · 2d ago',
    image: 'linkedin-alt',
  },
];

/** @deprecated Legacy — use NEXUS_LINKEDIN_ADS_ITEMS / NEXUS_META_ADS_ITEMS */
export const NEXUS_ADS_ITEMS = [];

export const NEXUS_META_ADS_ITEMS = [
  {
    platform: 'meta',
    company: 'MassMutual',
    title: 'The Feeling is MassMutual',
    subtitle: 'Meta · Facebook & Instagram video',
    time: 'Active · seen today',
    image: 'meta',
  },
  {
    platform: 'meta',
    company: 'MassMutual',
    title: 'Plan for your future',
    subtitle: 'Meta · NHL partnership creative',
    time: 'Active · 3d ago',
    image: 'meta-alt',
  },
];

export const NEXUS_COMPETITORS = [
  'Allianz Life',
  'MassMutual',
  'Pacific Life',
  'Lincoln',
  'Prudential',
];
